import $ from "jquery";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
import "@fancyapps/fancybox/dist/jquery.fancybox";
import { downloadImage } from "./functions";

const imageLinkPatterns = [
  'a.lightbox',
  'a[href*=".jpg"]',
  'a[href*=".png"]',
  'a[href*=".jpeg"]',
  'a[href*=".webp"]',
  'a[href*=".gif"]',
];

const arrowTemplates = {
  arrowLeft: `
    <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
          <path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/>
        </svg>
      </div>
    </button>
  `,
  arrowRight: `
    <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
          <path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686-4.686-4.686-12.284 0-16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/>
        </svg>
      </div>
    </button>
  `,
};

const buildSelectorList = ({ includeWithin, excludeWithin = [] } = {}) => {
  return imageLinkPatterns
    .map(selector => {
      const base = includeWithin ? `${includeWithin} ${selector}` : selector;
      const exclusions = excludeWithin.map(exclusion => `:not(${exclusion} *)`).join('');
      return `${base}${exclusions}`;
    })
    .join(', ');
};

const createFancyOptions = ({ selector, thumbsParentEl }) => ({
  selector,
  loop: true,
  keyboard: true,
  hash: false,
  btnTpl: arrowTemplates,
  preventCaptionOverlap: true,
  transitionEffect: "fade",
  idleTime: 20,
  buttons: ["zoom", "slideShow", "fullScreen", "download", "thumbs", "close"],
  thumbs: {
    autoStart: true,
    hideOnClose: true,
    parentEl: thumbsParentEl,
    axis: "y",
  },
  caption(instance, item) {
    return $(this).find(".snl-gallery-caption").html();
  },
  mobile: {
    thumbs: false,
    preventCaptionOverlap: true,
    idleTime: false,
  },
});

const fancyLinkSelectors = buildSelectorList({
  excludeWithin: ["#news-releases-press-inquiries", ".wp-block-gallery"],
});

const fancyLinkSelectorsGallery = buildSelectorList({
  includeWithin: ".wp-block-gallery",
});

const fancyOptions = createFancyOptions({
  selector: fancyLinkSelectors,
  thumbsParentEl: ".fancybox-container",
});

const fancyOptionsGallery = createFancyOptions({
  selector: fancyLinkSelectorsGallery,
  thumbsParentEl: ".fancybox-container",
});

function buildCaptionBlocks(selector, isGallery = false) {
  const fancyImage = $(selector);
  let $isActive = "";
  const captionPopup = {
    captionRan: false,
    thumbnail: "caption", // default
    title: false,
    description: false,
    caption: false,
  };

  if (!fancyImage.length) {
    return;
  }

  fancyImage.each(function () {
    const $el = $(this);
    const $img = $("img", this);
    const $anchorSrc = $(this).attr("href");
    const imgSrc = $img.attr("src");
    // For gallery blocks, data-title/data-description may be absent; fall back to figcaption text.
    const $figcaption = $el.siblings("figcaption");
    let imgTitle = $img.attr("data-title") ?? $figcaption.text() ?? '';
    let imgDescription = '';
    const imgCaption = $img.attr("data-caption") ?? '';
    const belongsToGallery = isGallery || $el.parents(".blocks-gallery-grid, .wp-block-gallery").length > 0;
    let imgHash = $img.attr("data-title");

    if (imgHash) {
      imgHash.replace(/\s+/g, "-").toLowerCase();
    }

    // if href is empty, get img tag src.
    if ($anchorSrc == "" && imgSrc) {
      $(this).attr("href", imgSrc);
    }

    $el.attr("data-hash", imgHash);

    // Save image el if hash matches.
    // if (cleanHash && cleanHash.indexOf(imgHash) > -1) {
    //     $isActive = $el
    // }

    if (belongsToGallery) {
      $el.attr("data-fancybox", "gallery");
    }

    // Do actions according to gutenberg Gallery Options.
    if (!captionPopup.captionRan) {
      if ($el.parents(".snl-gallery__thumbnail--title").length) {
        captionPopup.thumbnail = "title";
      }

      if ($el.parents(".snl-gallery__fancybox--title").length || $el.parents(".snl-gallery__fancybox--description").length) {
        captionPopup.title = true;
      }

      if ($el.parents(".snl-gallery__fancybox--description").length) {
        captionPopup.description = true;
      }

      if ($el.parents(".snl-gallery__fancybox--caption").length) {
        captionPopup.caption = true;
      }

      if ($el.parents(".snl-gallery__fancybox--hide-gallery").length) {
        // Target the correct options object so shared state isn't polluted.
        if (isGallery) {
          fancyOptionsGallery.thumbs.autoStart = false;
        } else {
          fancyOptions.thumbs.autoStart = false;
        }
      }
    }

    captionPopup.captionRan = true; // only capture config once for all items.
    // Replace thumbnail caption
    if (captionPopup.thumbnail == "title") {
      let formattedText = imgTitle;
      $el.next("figcaption").text(formattedText);
    }

    if (captionPopup.description != false) {
      // Prefer data-description attribute; fall back to figcaption for Gutenberg gallery blocks.
      imgDescription = $img.attr("data-description") ?? $figcaption.text() ?? '';
    }

    // Build new caption HTML and add it to the gallery,
    let popupHTML = `<div class="snl-gallery-caption d-none">`;
    if (captionPopup.title) {
      
      if (captionPopup.caption) {
        popupHTML += `<span class="d-block mb-5" style="text-align: center;font-style: italic;">${imgCaption}</span>`;
      }

      if($el.parents(".snl-gallery__fancybox--title").length == 0){
        imgTitle = '';
      }
      
      if (/^\d/.test(imgTitle)) {
        let matchedNumber = imgTitle.match(/^\d+/)[0];
        const regex = /^\d+/;
        let formattedTitle = imgTitle.replace(regex, "");

        popupHTML += `<h3 style="margin:0;"><span style="margin-right:20px; font-size:60px; color:white;">${matchedNumber}</span>${formattedTitle}</h3> <p style="padding-top:15px;">${imgDescription}</p>`;
      } else {
        if (imgTitle === '' && imgDescription === '' && imgCaption === '' ) {
          popupHTML += `<p style="padding-top:15px;">Image Gallery</p>`;
        } else {
          popupHTML += `<h3 style="margin:0;">${imgTitle}</h3> <p style="padding-top:15px;">${imgDescription}</p>`;
        }
      }
    } else {
      if (captionPopup.caption != false) {
        popupHTML += `<h3>${imgCaption}</h3>`;
      }
      else {
        popupHTML = '';
      }
    }

    popupHTML += `</div>`;
    $el.append(popupHTML);
  });

  // show captions after they have reloaded.
  // Commenting out for now - removing special number format on media galleries

  // $('figcaption').each(function() {
  //   let formattedText = $(this).text();
  //     if(/^\d/.test(formattedText))
  //     {
  //       let matchedNumber1 = formattedText.match(/^\d+/)[0];
  //       const regex = /^\d+/;
  //       let formattedTitle1 = formattedText.replace(regex, '');
  //       formattedText = `<span style="padding-right: 10px; font-size:16px; color: white !important; margin: 0; display: inline-block;">${matchedNumber1}</span><span style="display: inline-block; margin: 0; font-size: 12px">${formattedTitle1}</span>`;

  //       $(this).html(formattedText);
  //     }
  // });

  // Trigger click for lightbox when figcaption covers img.
  $("figcaption").css("cursor", "pointer");
  $("figcaption").on("click", function () {
    $(this).parent("figure").find(`> ${selector}`).click();
  });
}

$(function () {
  buildCaptionBlocks(fancyLinkSelectors);
  buildCaptionBlocks(fancyLinkSelectorsGallery, true);

  if( ! $('.wp-block-gallery .wp-block-image a').length ){
    $('.wp-block-gallery .wp-block-image').each(function(){
      if( $(this).parents(".snl-gallery__thumbnail--title").length ){
        const imgTitle = $(this).find('img').attr("data-title") ?? '';
        $(this).find('figcaption').text(imgTitle);
      }
      else if( $(this).parents(".snl-gallery__thumbnail--caption").length == 0 ){
        $(this).find('figcaption').remove();
      }
    });
  }

  $("figcaption").css("opacity", "1");
  // call fancybox on the gallery or individual images.
  $().fancybox(fancyOptions);
  $().fancybox(fancyOptionsGallery);

  // Add fancybox to iframe embed videos.
  const embedVideos = ".wp-block-embed.fancybox";
  const $fbEl = $(embedVideos);

  $fbEl.each(function () {
    const iframeSrc = $("iframe", this).attr("src");
    $(this).prepend(
      `<a class="lightbox w-100 h-100 d-block fancy__iframe-link" data-fancybox href="${iframeSrc}"></a>`
    );
  });

  const cleanHash = window.location.hash
    .replace("#", "")
    .replace(/-([^-]*)$/, "")
    .replace("%20", " ");

    console.log(cleanHash);

  if (cleanHash && $(`a[data-hash^="${cleanHash}"]`).length) {
    $(`a[data-hash^="${cleanHash}"]`).click();
  }
});

// Making the Gallery more responsive to different screen widths
$(function () {
  var originalCount = $(".wp-block-gallery").attr("class");
  if (originalCount) {
    var columnCount = originalCount.indexOf("columns-");
    originalCount = originalCount.substring(columnCount, columnCount + 9);
    $(window).resize(function () {
      let windowWidth = $(window).width();

      if (windowWidth > 992) {
      }
      if (windowWidth <= 992 && originalCount == "columns-5") {
        $("." + originalCount)
          .addClass("columns-3")
          .removeClass(originalCount);
      }
      if (windowWidth <= 992 && originalCount == "columns-4") {
        $("." + originalCount)
          .addClass("columns-3")
          .removeClass(originalCount);
      }
      if (windowWidth > 992 && originalCount == "columns-5") {
        $(".columns-3").addClass(originalCount).removeClass("columns-3");
      }
      if (windowWidth > 992 && originalCount == "columns-4") {
        $(".columns-3").addClass(originalCount).removeClass("columns-3");
      }
      if (windowWidth <= 770) {
        $(".columns-3").addClass("columns-2").removeClass("columns-3");
      }
      if (
        windowWidth > 770 &&
        windowWidth < 992 &&
        originalCount != "columns-2"
      ) {
        $(".columns-2").addClass("columns-3").removeClass("columns-2");
      }
      if (windowWidth > 992 && originalCount != "columns-2") {
        $(".columns-2").addClass(originalCount).removeClass("columns-2");
      }
      if (windowWidth <= 600) {
        $(".columns-2").addClass("columns-1").removeClass("columns-2");
      }
      if (
        windowWidth > 600 &&
        windowWidth < 770 &&
        originalCount != "columns-1"
      ) {
        $(".columns-1").addClass("columns-2").removeClass("columns-1");
      }
      if (windowWidth > 992 && originalCount != "columns-1") {
        $(".columns-1").addClass(originalCount).removeClass("columns-1");
      }
    });
  }
});

// Fix for lightbox "download" btn.
$("body").on("click", ".fancybox-button--download", downloadImage);